// extracted by mini-css-extract-plugin
export default {"messageContainer":"message_messageContainer__INJmB","correct":"message_correct__469Ld","error":"message_error__CyxJ5"};